import { useCallback } from 'react'
import { toast } from 'react-toastify'

export default ({ history, deleteIngredient, setShowDeleteModal }) => {

  const onDelete = useCallback(
    item => deleteIngredient(item.id).then(() => {
      toast.success(`Ingredient '${item.name}' deleted`, {
        position: toast.POSITION.TOP_RIGHT,
      })
    }),
    [deleteIngredient],
  )

  const handleDelete = useCallback(
    item => setShowDeleteModal(item),
    [setShowDeleteModal],
  )

  const onEdit = useCallback(
    item => {
      history.push(`/ingredients/${item.id}`)
    },
    [history],
  )

  return {
    onDelete,
    onEdit,
    handleDelete,
  }
}
